import { ReactComponent as Error } from '@public/icons/error.svg';
import Icon from '../atoms/Icon';

const IconError = (props) => <Icon as={Error} {...props} />;

IconError.propTypes = Icon.propTypes;

export default IconError;
